import { type ReactElement } from 'react'
import { Skeleton } from '@mantine/core'

export const PreferenceSkeleton = (): ReactElement => {
  return <Skeleton h={50} w='100%' />
}
